const horizontalPositions = ['left', 'middleleft', 'middleright', 'right'];
const verticalPositions = ['bottom', 'middle', 'top'];

/**
 * Display all beat positions at once.
 */
AFRAME.registerComponent('debug-beat-positioning', {
  play: function () {
    let mode = AFRAME.utils.getUrlParameter('debugbeatpositioning');
    if (!mode) { return; }
    if (mode !== 'punch' && mode !== 'classic') { mode = 'classic'; }

    this.el.emit('debugbeatpositioning');

    setTimeout(() => {
      const generator = this.el.sceneEl.components['beat-generator'];
      generator.data.gameMode = mode;
      scene.components['beat-system'].data.gameMode = mode;
      scene.components['beat-system'].updateBeatPositioning();

      horizontalPositions.forEach(hPos => {
        verticalPositions.forEach(vPos => {
          let beatEl = generator.requestBeat(mode === 'punch' ? 'dot' : 'arrow', 'red');
          let dir = Math.random() < 0.5 ? 'left' : 'right';
          beatEl.components.beat.onGenerate(0.001, hPos, vPos, dir);
          beatEl.object3D.renderOrder = 9999;
          beatEl.play();

          beatEl = generator.requestBeat('dot', 'blue');
          dir = Math.random() < 0.5 ? 'down' : 'up';
          beatEl.components.beat.onGenerate(0.0015, hPos, vPos, dir);
          beatEl.object3D.renderOrder = 9999;
          beatEl.play();
        });
      });

      const wallEl = scene.components.pool__wall.requestEntity();
      wallEl.components.wall.onGenerate(0.0015, 'left', 4, 4, true);
      wallEl.play();

      document.getElementById('beatContainer').removeAttribute('bind__visible');
      document.getElementById('beatContainer').object3D.visible = true;
    }, 500);
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['debug-beat-positioning',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
